import React from 'react';
import PropTypes from 'prop-types';

function Well({ children })
{
    return <div className="tw-min-h-screen tw-bg-ivory-background dark:tw-bg-neutral-800 dark:tw-text-gray-100 tw-font-default">{children}</div>;
}

Well.propTypes = {
    children: PropTypes.node.isRequired,
};

export default Well;
